
var initialState =
{
    panelingDirection: "vaaka"
}
const paneling = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_PANEL_MATERIAL':
            return Object.assign({}, state, {
                panelMaterial: action.id
            })
        case 'CHANGE_PANELINGDIRECTION':
            return Object.assign({}, state, {
                panelingDirection: action.direction
            })
        case 'PLAN_LOADED':
            return Object.assign({}, state, {
                panelMaterial: action.plan.PanelMaterial
            })
        case 'MATERIAL_STORE_UPDATED':
             return Object.assign({}, state, {
                 panelMaterial: action.defaultPanelMaterial
             })
        default:
            return state;
    }
}

export default paneling
